module.exports = __webpack_public_path__ + "img/sub5.1e5bd06f.jpg";